<template>
  <a-modal title="新增查询办件配置" :visible="visible" :maskClosable="false" :width="960" destroyOnClose
           @cancel="$emit('cancel')">
  <template slot="footer">
      <a-button key="submit" :loading="loading" type="primary" @click="submit">确定</a-button>
      <a-button key="back" @click="$emit('cancel')">取消</a-button>
    </template>
    <a-form :form="form" class="custom pick-100 form-input">
      <a-row>
        <a-col :span="21" :offset="1">
          <a-form-item label="访问路径">
            <a-input v-decorator="['webPath', { initialValue: initData.webPath, rules: [{ required: true, message: '请输入访问路径' }]}]" placeholder="请输入访问路径"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="21" :offset="1">
          <a-form-item label="状态">
            <a-radio-group v-decorator="['state', { initialValue: initData.state, rules: [{ required: true, message: '请选择状态' }]}]">
              <a-radio value="E">启用</a-radio>
              <a-radio value="D">禁用</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import qs from 'qs'

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      form: this.$form.createForm(this),
      initData: {
        userId: '',
        state: 'E'
      }
    }
  },
  created () {
  },
  methods: {
    submit () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (err) {
          this.loading = false
          return
        }
        const that = this
        let data = that.form.getFieldsValue()
        this.$http.post('/api/1/workflow/config/add_config.json', qs.stringify(data, { allowDots: true })).then(function (response) {
          that.$message.success('保存成功')
          that.$emit('success')
          that.loading = false
        })
      })
    }
  }
}
</script>

<style scoped></style>
